import React from 'react';
import { usePopupNotifications } from '../hooks/usePopupNotifications';
export function PopupNotification() {
  const {
    currentPopup,
    isVisible
  } = usePopupNotifications();
  if (!currentPopup) return null;
  return <div className={`fixed bottom-5 left-5 bg-brand-dark2 border border-brand-border border-l-4 border-l-brand-green rounded-xl px-4 py-3 max-w-[300px] z-[8888] flex items-center gap-3 shadow-[0_8px_32px_rgba(0,0,0,0.5)] transition-transform duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)] ${isVisible ? 'translate-x-0' : '-translate-x-[120%]'}`} data-id="element-210">
      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-brand-red to-brand-darkRed flex items-center justify-center text-lg shrink-0" data-id="element-211">
        {currentPopup.emoji}
      </div>
      <div className="flex-1" data-id="element-212">
        <p className="text-xs text-brand-light leading-snug" data-id="element-213">
          <strong className="text-brand-yellow" data-id="element-214">{currentPopup.name}</strong> de{' '}
          {currentPopup.city}
          <br data-id="element-215" />
          {currentPopup.action}
        </p>
        <p className="text-[11px] text-brand-gray mt-1" data-id="element-216">{currentPopup.time}</p>
      </div>
      <div className="w-2 h-2 bg-brand-green rounded-full shrink-0 animate-blink" data-id="element-217"></div>
    </div>;
}